export default "__VITE_ASSET__C1A5pvaF__"